import React from 'react'
import { injectIntl } from 'react-intl'
import Translation from '../global/Translation'
import DisplayNewIndicator from './rectangleResult/displays/DisplayNewIndicator'
import DisplayUpcomingIndicator from './rectangleResult/displays/DisplayUpcomingIndicator'
import DisplayOutletIndicator from './rectangleResult/displays/DisplayOutletIndicator'
import DisplayDiscontinued from './rectangleResult/displays/DisplayDiscontinued'
import DisplayTechnology from './rectangleResult/displays/DisplayTechnology'
import DisplayBlackIndicator from './rectangleResult/displays/DisplayBlackIndicator'
import DisplayHomeDepotIndicator from './rectangleResult/displays/DisplayHomeDepotIndicator'
import NaturalStoneIndicator from '../cart-line/indicators/NaturalStoneIndicator'
import CustomProductIndicator from '../cart-line/indicators/CustomProductIndicator'

const LegendOfLabelsContent = props => (
    <React.Fragment>
            {/* Technology */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="technology" defaultMessage="Technology" />:
                </h5>
                <div className="legend__card--content">
                    {/*<div>*/}
                    {/*    <DisplayTechnology subBrand={'xm'} desktopWidth={'104px'} desktopHeight={'34px'} withBorder={true} />*/}
                    {/*    <p>*/}
                    {/*        <Translation*/}
                    {/*            id="silestone_xm_is_our_designer_mineral_surface_with_a_maximum_content"*/}
                    {/*            defaultMessage="Silestone®XM is our designer mineral surface with a maximum content of 10% crystalline silica."*/}
                    {/*        />*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                    <div>
                        <DisplayTechnology technology={'hybriq'} desktopWidth={'96px'} desktopHeight={'34px'} withBorder={true} />
                        <p>
                            <Translation
                                id="all_products_with_the_hybriq_label_have_a_maximum"
                                defaultMessage="All products with the HYBRIQ® label have a maximum crystalline silica content of 40%."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayTechnology technology={'ukiyo'} desktopWidth={'82px'} desktopHeight={'34px'} withBorder={true} />
                        <p>
                            <Translation
                                id="silestone_ukiyo_offers_full_continuity_of_veining_throughout_its_thickness_with_vertical_grooving"
                                defaultMessage="Silestone UKIYO offers full continuity of veining throughout its thickness, with vertical grooving that exposes color integration and material depth for advanced design solutions."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayTechnology technology={'optimma'} desktopWidth={'98px'} desktopHeight={'34px'} withBorder={true} />
                        <p>
                            <Translation
                                id="optimma_2600_x_1000_the_most_versatile_format_for_interior_cladding_in_dekton"
                                defaultMessage="Optimma 2600 X 1000 mm, the most versatile format for interior cladding in Dekton®."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayTechnology technology={'grip+'} desktopWidth={'96px'} desktopHeight={'34px'} withBorder={true} />
                        <p>
                            <Translation
                                id="dekton_grip_plus_is_the_anti_slip_treatment_for_those_areas_that_by_regulation_require_a_superior_grip"
                                defaultMessage="Dekton® Grip+ is the anti-slip treatment for those areas that by regulation require a superior grip, and is not recommended for areas where it is not necessary."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayTechnology technology={'nboost'} desktopWidth={'94px'} desktopHeight={'34px'} withBorder={true} />
                        <p>
                            <Translation
                                id="silestone_n_noost_is_an_advanced_silestone_technological_process_that_further_enhances_the_excellent_technical_and_aesthetic_performance_of_the_worktop"
                                defaultMessage="Silestone® N-Boost is an advanced Silestone® technological process that further enhances the excellent technical and aesthetic performance of the worktop."
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Discontinued */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="discontinued" defaultMessage="Discontinued" />:
                </h5>
                <div className="legend__card--content">
                {/* $allowedStatuses = ['LD', 'DD', 'DE', 'DF', 'DA']; */}
                    <div>
                        <DisplayDiscontinued discontinued={'LD'} displayInLine={true} />
                        <p>
                            <Translation
                                id="this_material_has_been_discontinued_and_will_no_longer_be_produced_the_product_will_remain_available_for_purchase_while_supplies_last"
                                defaultMessage="This material has been discontinued and will no longer be produced. The product will remain available for purchase while supplies last."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayDiscontinued discontinued={'DF'} displayInLine={true} />
                        <p>
                            <Translation
                                id="this_material_is_discontinued_due_to_reformulation_so_it_will_no_longer_be_produced"
                                defaultMessage="This material is discontinued due to reformulation, so it will no longer be produced. It will be available while supplies last and you will be able to find it in another format."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayDiscontinued discontinued={'DD'} displayInLine={true} />
                        <p>
                            <Translation
                                id="this_material_is_discontinued_by_format_so_it_will_no_longer_be_produced"
                                defaultMessage="This material is discontinued by format, so it will no longer be produced. It will be available while stocks last and you will be able to find it in another format."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayDiscontinued discontinued={'DA'} displayInLine={true} />
                        <p>
                            <Translation
                                id="this_material_is_discontinued_by_finish_so_it_will_no_longer_be_produced"
                                defaultMessage="This material is discontinued by finish, so it will no longer be produced. It will be available while stocks last and you will be able to find it with another finish."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayDiscontinued discontinued={'DE'} displayInLine={true} />
                        <p>
                            <Translation id="this_material_is_discontinued_by_thickness_so_it_will_no_longer_be_produced" defaultMessage="This material is discontinued by thickness, so it will no longer be produced. It will be available while stocks last and you will be able to find it with another thickness." />
                        </p>
                    </div>
                </div>
            </div>

            {/* Outlet */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="outlet" defaultMessage="Outlet" />:
                </h5>
                <div className="legend__card--content">
                    <div>
                        <DisplayOutletIndicator outletQuality={'X'} displayInLine={true} />
                        <p>
                            <Translation
                                id="discontinued_material_with_the_highest_discount_applied"
                                defaultMessage="This item is priced much lower because it is from previous collections (more than two years old). It will be available for purchase while supplies last."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayOutletIndicator outletQuality={'O'} displayInLine={true} />
                        <p>
                            <Translation
                                id="discontinued_material_with_intermediate_discount_applied_availability_limited_to_current_stock"
                                defaultMessage="This material is on sale because it is from previous collections. It will be available for purchase while supplies last."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayOutletIndicator outletQuality={'V'} displayInLine={true} />
                        <p>
                            <Translation
                                id="discontinued_material_with_discount_applied_availability_limited_to_current_stock"
                                defaultMessage="This material is part of the initial batch and is currently available at a promotional discount. It will be available for purchase while supplies last."
                            />
                        </p>
                    </div>
                     <div>
                        <DisplayOutletIndicator outletQuality={'W'} displayInLine={true} />
                        <p>
                            <Translation
                                id="discontinued_material_with_premium_discount_applied"
                                defaultMessage="This material is part of our premium collection and is currently available at a promotional discount. It will be available for purchase while supplies last."
                            />
                        </p>
                    </div>
                    <div>
                        <NaturalStoneIndicator idMessage={'outlet_in_hq'} defaultMessage="Outlet Spain" />
                        <p>
                            <Translation id="this_product_is_available_at_our_spain_center" defaultMessage="This product is available at our Spain Center." />
                        </p>
                    </div>
                </div>
            </div>

            {/* Price */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="price" defaultMessage="Price" />:
                </h5>
                <div className="legend__card--content">
                    <div>
                        <DisplayBlackIndicator value={'-10%'} />
                        <p>
                            <Translation id="discount_applied_to_the_final_price_of_the_product" defaultMessage="Discount applied to the final price of the product." />
                        </p>
                    </div>
                    <div>
                        <DisplayBlackIndicator value={props.intl.formatMessage({ id: 'new_price' })} />
                        <p>
                            <Translation
                                id="displays_the_exclusive_reduced_price_for_this_product"
                                defaultMessage="Displays the exclusive reduced price for this product."
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Novedades */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="NEWS" defaultMessage="News" />
                </h5>
                <div className="legend__card--content">
                    <div>
                        <DisplayUpcomingIndicator />
                        <p>
                            <Translation
                                id="this_product_will_be_available_within_15_days"
                                defaultMessage="This product will be available within 15 days. You can add it to your cart and checkout, the product will be shipped when available."
                            />
                        </p>
                    </div>
                    <div>
                        <DisplayNewIndicator />
                        <p>
                            <Translation
                                id="recently_launched_belonging_to_our_latest_collection"
                                defaultMessage="Recently launched, belonging to our latest collection."
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Natural stone */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="natural_stone" defaultMessage="Natural Stone" />:
                </h5>
                <div className="legend__card--content" style={{ gridTemplateColumns: 'repeat(1, 1fr)' }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <NaturalStoneIndicator idMessage={'natural_stone_hq'} defaultMessage="Natural stone Spain" inSmallBox={true} />
                            <NaturalStoneIndicator idMessage={'natural_stone_brazil'} defaultMessage="Natural stone Brazil" inSmallBox={true} />
                        </div>
                        <p>
                            <Translation
                                id="natural_stone_material_that_is_available_from_the_central_warehouse_in_spain_or_brazil"
                                defaultMessage="Natural stone material that is available from the central warehouse in Spain or Brazil."
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Others */}
            <div className="legend__card">
                <h5 className="legend__card--title">
                    <Translation id="OTHERS" defaultMessage="Others" />:
                </h5>
                <div className="legend__card--content">
                    {props.isUsaOrCanada && (
                        <div>
                            <DisplayHomeDepotIndicator />
                            <p>
                                <Translation
                                    id="this_product_is_only_available_for_certain_purchases_and_or_customers_with_a_pre_established_relationship_with_home_depot"
                                    defaultMessage="This product is only available for certain purchases and/or customers with a pre-established relationship with Home Depot."
                                />
                            </p>
                        </div>
                    )}
                    <div>
                        <CustomProductIndicator customWidth={'54px'} />
                        <p>
                            <Translation id="tailor_made_product_subject_to_special_conditions" defaultMessage="Tailor-made product. Subject to special conditions." />
                        </p>
                    </div>
                </div>
            </div>
    </React.Fragment>
)

export default injectIntl(LegendOfLabelsContent)
